import React from 'react';
import { Linkedin, Twitter, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { useLanguage } from '../context/LanguageContext';

const content = {
  es: {
    suptitle: 'Quienes estan detras de ColaboraChile',
    title: 'Founders',
    visionTitle: 'Nuestra vision',
    visionP1: 'Creemos que la colaboracion en un ecosistema de emprendimiento e innovacion es el motor que potencia el exito de todos los actores.',
    visionP2: 'Nuestra vision es contar con una red potente y con impacto, que permita relaciones virtuosas entre las grandes empresas y las startups, donde se solucionan problemas o dolores y emergen innovaciones disruptivas y creativas.',
    visionP3: 'ColaboraChile emerge desde nuestro quehacer en Consulting Design (cdesign.cl) y nuestra trayectoria de mas de 10 años en el ecosistema de emprendimiento e innovacion.',
  },
  en: {
    suptitle: 'Who is behind ColaboraChile',
    title: 'Founders',
    visionTitle: 'Our vision',
    visionP1: 'We believe that collaboration in an entrepreneurship and innovation ecosystem is the engine that drives the success of all actors.',
    visionP2: 'Our vision is to have a powerful and impactful network that enables virtuous relationships between large companies and startups, where problems are solved and disruptive, creative innovations emerge.',
    visionP3: 'ColaboraChile emerges from our work at Consulting Design (cdesign.cl) and our trajectory of more than 10 years in the entrepreneurship and innovation ecosystem.',
  },
};

const founders = [
  {
    name: 'Diego Rodriguez',
    role: 'Founder',
    image: 'https://customer-assets.emergentagent.com/job_78e4354f-c3d1-4776-8bc6-7f8d8b40d622/artifacts/whefsoa9_diego_web.jpg',
    linkedin: 'https://www.linkedin.com/in/diegorodriguezbastias-innovacion/',
    twitter: 'https://twitter.com/diegrod',
    website: 'http://www.cdesign.cl/',
  },
  {
    name: 'Felipe Gonzalez',
    role: 'Founder',
    image: 'https://customer-assets.emergentagent.com/job_78e4354f-c3d1-4776-8bc6-7f8d8b40d622/artifacts/ejjpnakw_FelipeGonzalez.jpg',
    linkedin: 'https://www.linkedin.com/in/felipe-gonzalez-rojas/',
    twitter: 'https://twitter.com/feligonzalez',
  },
];

const Founders = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative py-20 lg:py-28" style={{ backgroundColor: '#6949b6' }}>
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/40 to-transparent"></div>
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-purple-200 text-sm font-medium uppercase tracking-widest mb-4">{t.suptitle}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white" data-testid="founders-title">
            {t.title}
          </h1>
        </div>
      </section>

      {/* Vision */}
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">{t.visionTitle}</h2>
          <div className="space-y-5 text-gray-700 text-lg leading-relaxed">
            <p>{t.visionP1}</p>
            <p>{t.visionP2}</p>
            <p>{t.visionP3}</p>
          </div>
        </div>
      </section>

      {/* Founders Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {founders.map((founder) => (
              <Card key={founder.name} className="overflow-hidden border-0 shadow-lg" data-testid={`founder-${founder.name.split(' ')[0].toLowerCase()}`}>
                <div className="aspect-square max-w-[280px] mx-auto overflow-hidden rounded-lg bg-gray-100">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900">{founder.name}</h3>
                  <p className="text-sm font-medium mb-4" style={{ color: '#6949b6' }}>{founder.role}</p>
                  <div className="flex justify-center gap-4">
                    {founder.linkedin && (
                      <a href={founder.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-600 transition-colors" aria-label="LinkedIn">
                        <Linkedin className="w-5 h-5" />
                      </a>
                    )}
                    {founder.twitter && (
                      <a href={founder.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-sky-500 transition-colors" aria-label="Twitter">
                        <Twitter className="w-5 h-5" />
                      </a>
                    )}
                    {founder.website && (
                      <a href={founder.website} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-700 transition-colors" aria-label="Website">
                        <ExternalLink className="w-5 h-5" />
                      </a>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Founders;
